import { SlotsState } from '../types/slotsState';

const getSlots = (state: { extensionsSlots: SlotsState }) =>
  state.extensionsSlots;

export { getSlots };
